import * as types from "./mutation-type";
import { getOvertimeRulesQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getOvertimeRules({ commit }, variables = {}) {
    try {
      commit(types.GET_OVERTIME_RULES_BEGIN);
      const {
        data: {
          data: {
            company: {
              overtimeRules
            }
          }
        }
      } = await gqlClient.query({
        query     : getOvertimeRulesQuery,
        variables : variables
      });
      commit(types.GET_OVERTIME_RULES_SUCCESS, overtimeRules);
    } catch (e) {
      commit(types.GET_OVERTIME_RULES_ERROR, e);
    }
  },

  async deleteOvertimeRules({ commit }, id) {
    try {
      commit(types.DELETE_OVERTIME_RULE_BEGIN);
      await api.overtimeRule.deleteOvertimeRule(id);

      commit(types.DELETE_OVERTIME_RULE_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_OVERTIME_RULE_ERROR, e);
    }
  },

  async applyOvertimeRules({ commit }, variables = {}) {
    try {
      commit(types.APPLY_OVERTIME_RULE_BEGIN);
      await api.process.applyOvertimeRule(variables);
      
      commit(types.APPLY_OVERTIME_RULE_SUCCESS);
    } catch (e) {
      commit(types.APPLY_OVERTIME_RULE_ERROR, e);
    }
  }
};

export default actions;
